/* eslint angular/document-service: 0 */
(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'youtube', {
            bindings: {
                id:   '<',
                play: '='
            },
            templateUrl:  'app/views/partials/widgets/youtube.html',
            controller:   YoutubeController,
            controllerAs: 'vm'
        });



    /** SHARED MEMBERS. */

    /** @type {boolean} */
    var currentlyPlaying = null,
    isApiInitialised     = false;



    /**
     * @param {ng.IScope} $scope
     */
    function YoutubeController( $scope ){

        /** @type {angular.IController} */
        var vm        = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        var isInitialised = false;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.video = {
            id:       null,
            visible:  false,
            toggle:   toggle,
            properties: {
                autoplay: 1,
                rel:      0
            }
        };





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            if ( !isApiInitialised ) initApi();
        };





        /* ===== PUBLIC METHODS ============================================= */


        function toggle(){
            vm.video.visible = !vm.video.visible;
            vm.play          = vm.video.visible;
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        // Uni-directional watcher
        vm.$onChanges = function( changesObject ) {
            if ( changesObject.id && changesObject.id.currentValue && !isInitialised ) {
                vm.video.id   = changesObject.id.currentValue;
                isInitialised = true;
            }
        };


        // Bi-directional watcher
        $scope.$watch( 'vm.play', function ( shouldPlay) {
            if ( shouldPlay == vm.video.visible ) return;

            if ( isInitialised && shouldPlay) {

                // 1. Turn off any other video first
                if ( currentlyPlaying ){
                    currentlyPlaying.toggle();
                }

                // 2. Play
                currentlyPlaying = vm.video;
                vm.video.toggle();

            } else if ( isInitialised && !shouldPlay ){
                vm.video.visible = false;
                currentlyPlaying = null;
            }
        });


        function initApi(){
            var tag        = document.createElement( 'script' );
            tag.src        = "https://www.youtube.com/iframe_api";

            var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
            firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
            isApiInitialised = true;
        }
    }



    YoutubeController.$inject = [ '$scope' ];
})();
